import { selectKrcCurriculumClusterNode } from '@newStore/documentUI/transformContent/krcContentNodeSelectors';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { minimumGoalComponent } from '@nodeTypeConfig/helpers/editComponents/minimumGoalComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const KRC_CURRICULUM_CLUSTER: BuildingBlockNodeConfig = {
  nodeSelector: selectKrcCurriculumClusterNode,
  information: {
    single: 'Cluster',
    plural: 'Clusters',
  },
  buildingBlocks: [{ type: NodeType.KRC_GOAL_SET_ITEM }],
  edit: [
    {
      ...titleComponent,
      width: 12,
    },
    minimumGoalComponent,
  ],
  documentViewIdentifier: 'i',
  isCollapsible: true,
  onNewNodeDropped: {
    focusOnField: 'title',
  },
};

export default KRC_CURRICULUM_CLUSTER;
